import React from 'react';
import {Layout, Menu, Typography} from "antd";
import classes from './NavBar.module.scss';
import {
  AccountBookOutlined,
  AppstoreOutlined, FileTextOutlined,
  IssuesCloseOutlined,
  TeamOutlined,
  TransactionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {ROUTES} from "../../AppRouter/AppRouter";
import {Link, useNavigate} from "react-router-dom";
import {useEnhancedLocation} from "../../../hooks/useEnhancedLocation";
import {logout} from "../../../store/actions/app";

const NavBar = () => {
  const location = useEnhancedLocation();
  const navigate = useNavigate();

  const items = [
    {
      label: 'Transactions',
      key: ROUTES.DASHBOARD.key,
      icon: <TransactionOutlined/>,
    },
    {
      label: 'Reports',
      key: ROUTES.REPORTS.key,
      icon: <FileTextOutlined />,
    },
    {
      label: 'Ledger',
      key: ROUTES.LEDGER.key,
      icon: <AccountBookOutlined />,
    },
    {
      label: 'Day close operation',
      key: ROUTES.CLOSE_DAY.key,
      icon: <IssuesCloseOutlined />,
    },
    {
      label: 'Tariffs',
      key: ROUTES.TARIFFS.key,
      icon: <AppstoreOutlined />,
    },
    {
      label: 'Users',
      key: ROUTES.USERS.key,
      icon: <TeamOutlined/>,
    },
    {
      label: 'Account',
      key: 'account',
      icon: <UserOutlined/>,
      children: [
        {
          label: 'Log out',
          key: 'logout',
          danger: true,
        },
      ],
    },
  ];

  const handleClick = ({key}) => {
    if (key === 'logout') return logout();
    else {
      const route = Object.values(ROUTES).find(route => route.key === key);
      if (route) navigate(route.path);
    }
  };

  return (
    <Layout.Header className={classes.container}>
      <Link style={{height: '100%', display: 'flex', alignItems: 'center'}} to={ROUTES.DASHBOARD.path}>
        <Typography.Title style={{marginBottom: 0, paddingInline: 10}} level={2}>TigsiPay</Typography.Title>
      </Link>
      <Menu style={{minWidth: 0, flexGrow: 1, justifyContent: 'flex-end'}} onClick={handleClick}
            selectedKeys={[location.routeKey]} mode="horizontal" items={items}/>
    </Layout.Header>
  );
};
export default NavBar;
